import { render, staticRenderFns } from "./purchaseSaleStore.vue?vue&type=template&id=34b0aa45&scoped=true"
import script from "./purchaseSaleStore.vue?vue&type=script&lang=js"
export * from "./purchaseSaleStore.vue?vue&type=script&lang=js"
import style0 from "./purchaseSaleStore.vue?vue&type=style&index=0&id=34b0aa45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0aa45",
  null
  
)

export default component.exports